/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import r from "./flow/BrushFlow.js";
import s from "./webgl/brushes/BrushBitmap.js";
import e from "./webgl/brushes/BrushClip.js";
import l from "./webgl/brushes/WGLBrushInfo.js";
import o from "./webgl/brushes/WGLBrushStencil.js";
import { WGLBrushVTLBackground as t } from "./webgl/brushes/WGLBrushVTLBackground.js";
import { WGLBrushVTLCircle as m } from "./webgl/brushes/WGLBrushVTLCircle.js";
import { WGLBrushVTLFill as i } from "./webgl/brushes/WGLBrushVTLFill.js";
import { WGLBrushVTLLine as b } from "./webgl/brushes/WGLBrushVTLLine.js";
import { WGLBrushVTLSymbol as u } from "./webgl/brushes/WGLBrushVTLSymbol.js";
import h from "./webgl/brushes/WGLGeometryBrushFill.js";
import p from "./webgl/brushes/WGLGeometryBrushLabel.js";
import f from "./webgl/brushes/WGLGeometryBrushLine.js";
import B from "./webgl/brushes/WGLGeometryBrushMarker.js";
import L from "./webgl/brushes/WGLGeometryBrushText.js";
import g from "./webgl/brushes/raster/BrushRasterBitmap.js";
import w from "./webgl/brushes/raster/BrushVectorField.js";
var j = {
  marker: B,
  line: f,
  fill: h,
  text: L,
  label: p,
  clip: e,
  stencil: o,
  bitmap: s,
  raster: g,
  rasterVF: w,
  flow: r,
  tileInfo: l,
  vtlBackground: t,
  vtlFill: i,
  vtlLine: b,
  vtlCircle: m,
  vtlSymbol: u
},
    G = {
  vtlBackground: t,
  vtlFill: i,
  vtlLine: b,
  vtlCircle: m,
  vtlSymbol: u
};
export { j as brushes, G as vtlBrushes };